import { createFileRoute } from '@tanstack/react-router';

import { InlandPage, type InlandView, type YardFilter } from '@/features/operator/inland-page';

const MATCHES: YardFilter[] = ['ZIP', 'NEAREST', 'STATE', 'NONE'];

/** Вид, фільтр і пошук — в адресі: посилання на «майданчики, знайдені лише за сусідом» має бути посиланням. */
export const Route = createFileRoute('/_operator/inland')({
	validateSearch: (raw: Record<string, unknown>): { view?: InlandView; match?: YardFilter; q?: string } => ({
		view: raw.view === 'yards' ? 'yards' : undefined,
		match: MATCHES.includes(raw.match as YardFilter) ? (raw.match as YardFilter) : undefined,
		q: typeof raw.q === 'string' && raw.q.trim() ? raw.q.slice(0, 80) : undefined,
	}),
	component: InlandPage,
});
